// extracted by mini-css-extract-plugin
module.exports = {"div":"spin_div__371-E","spin":"spin_spin__TZu8L"};